import axios from 'axios'
import { MODE } from '../constants/mode'
import { getMode } from '../hooks/mode'
import axiosMocked from '../mockHttp'
import { getStore, setStore, keys } from './localStorage'

const HEAD_REQUEST_TIMEOUT_MS = 3000
const REQUEST_TIMEOUT_MS = 60000
const NOT_KIOSK_ID = 'NOT-KIOSK'

const LocalStorageSessionGuid = 'CSC_SESSION_GUID'

export const LocalStorageID = 'CSC_ID'
export const getCSCId: () => string = () => getStore(LocalStorageID) || ''
export const setCSCId = (id: string) => setStore(LocalStorageID, id)

const TOKEN_ID = 'token'
export const getAdminToken = () => getStore(TOKEN_ID)
export const setAdminToken = (token: string) => setStore(TOKEN_ID, token)

function makeId(length: number) {
  if (getMode() !== MODE.KIOSK) {
    return NOT_KIOSK_ID
  }
  let result = ''
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  const charactersLength = characters.length
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}

const storedId = getCSCId()
if (!storedId || storedId === NOT_KIOSK_ID) {
  const newId = makeId(11)
  setCSCId(newId)
}

const http = () => {
  const mockHttp: boolean = getStore(keys.HTTP_MOCK)
  return mockHttp ? axiosMocked : axios
}

export const getSessionGuid: () => string = () => getStore(LocalStorageSessionGuid) || ''
export const setSessionGuid = (guid: string) => {
  setStore(LocalStorageSessionGuid, guid)
}

type GetRequest = (url: string, id: string) => Promise<{ data?: any }>
type PostRequest = (url: string, id: string, data?: any) => Promise<{ data?: any; status: number }>
type PutRequest = (url: string, data?: any) => Promise<{ data?: any; status: number }>
type DeleteRequest = (url: string) => Promise<{ status: number }>

type GetRequestAuth = (url: string, id: string, sessionGuId: string) => Promise<{ data?: any }>
type PostRequestAuth = (url: string, id: string, sessionGuId: string, data?: any) => Promise<{ data?: any; status: number }>
type PutRequestAuth = (url: string, id: string, sessionGuId: string, data?: any) => Promise<{ data?: any; status: number }>
type DeleteRequestAuth = (url: string, id: string, sessionGuId: string) => Promise<{ status: number }>

type CheckRequest = () => Promise<any>

const httpHeaders = () => ({
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: REQUEST_TIMEOUT_MS,
})

export const get: GetRequest = (url: string, id: string) => http().get(`${url}?id=${id}`, httpHeaders())
export const getAuth: GetRequestAuth = (url: string, id: string, sessionGuId: string) =>
  http().get(`${url}?sessionGUID=${sessionGuId}&id=${id}`, httpHeaders())
export const post: PostRequest = (url: string, id: string, data?: any) =>
  http().post(`${url}?id=${id}`, data || {}, httpHeaders())
export const postAuth: PostRequestAuth = (url: string, id: string, sessionGuId: string, data?: any) =>
  http().post(`${url}?sessionGUID=${sessionGuId}&id=${id}`, data, httpHeaders())
export const put: PostRequest = (url: string, data?: any) => http().put(`${url}`, data, httpHeaders())
export const putAuth: PutRequestAuth = (url: string, id: string, sessionGuId: string, data?: any) =>
  http().put(`${url}?sessionGUID=${sessionGuId}&id=${id}`, data, httpHeaders())
export const deleteAuth: DeleteRequestAuth = (url: string, id: string, sessionGuId: string) =>
  http().delete(`${url}?sessionGUID=${sessionGuId}&id=${id}`, httpHeaders())
export const selfCheckRequest: CheckRequest = () =>
  http().get('/favicon.ico',{
    timeout: HEAD_REQUEST_TIMEOUT_MS,
  })

const authHeaders = () => ({
  headers: {
    Authorization: `Bearer ${getAdminToken()}`,
    'Content-Type': 'application/json',
  },
})
export const adminGet = (url: string) => http().get(`${url}?id=${getCSCId()}`, authHeaders())
export const adminPost = (url: string, data?: any): Promise<{ data?: any; status: number }> => http().post(url, data, authHeaders())
export const adminPut: PutRequest = (url: string, data?: any) => http().put(url, data, authHeaders())
export const adminDelete: DeleteRequest = (url: string) => http().delete(url, authHeaders())
